import { useState, useEffect } from 'react'
import { supabase } from '../supabase'

const API = 'https://legado-digital-production.up.railway.app'

function Seguridad({ userId, onTimeoutChange }) {
  const [mensaje, setMensaje] = useState('')
  const [error, setError] = useState('')

  const [mfaActivado, setMfaActivado] = useState(false)
  const [mfaQR, setMfaQR] = useState('')
  const [mfaSecret, setMfaSecret] = useState('')
  const [mfaFactorId, setMfaFactorId] = useState('')
  const [mfaCodigo, setMfaCodigo] = useState('')
  const [mfaPaso, setMfaPaso] = useState('')
  const [mfaError, setMfaError] = useState('')
  const [timeoutSesion, setTimeoutSesion] = useState(localStorage.getItem('sesion_timeout') || 'inmediato')
  const [confirmarEliminar, setConfirmarEliminar] = useState(false)
  const [emailConfirm, setEmailConfirm] = useState('')
  const [eliminando, setEliminando] = useState(false)

  useEffect(() => {
    async function verificarMfa() {
      const { data } = await supabase.auth.mfa.listFactors()
      const factorActivo = data?.totp?.find(f => f.status === 'verified')
      if (factorActivo) {
        setMfaActivado(true)
        setMfaFactorId(factorActivo.id)
      }
    }
    verificarMfa()
  }, [userId])

  function guardarTimeout(valor) {
    setTimeoutSesion(valor)
    localStorage.setItem("sesion_timeout", valor)
    if (onTimeoutChange) onTimeoutChange(valor)
    setMensaje('Configuración de seguridad guardada.')
    setTimeout(() => setMensaje(''), 4000)
  }

  async function activarMfa() {
    setMfaError('')
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) {
        setMfaError('Sesión no válida. Cierra sesión y vuelve a entrar.')
        return
      }

      // Limpiar factores no verificados previos
      const { data: factoresData } = await supabase.auth.mfa.listFactors()
      const pendientes = factoresData?.totp?.filter(f => f.status === 'unverified') || []
      for (const factor of pendientes) {
        await supabase.auth.mfa.unenroll({ factorId: factor.id })
      }

      const { data, error } = await supabase.auth.mfa.enroll({
        factorType: 'totp',
        friendlyName: 'ETERN-ME'
      })
      if (error) {
        setMfaError(`Error al activar: ${error.message}`)
        return
      }
      setMfaQR(data.totp.qr_code)
      setMfaSecret(data.totp.secret)
      setMfaFactorId(data.id)
      setMfaPaso('configurando')
    } catch (err) {
      setMfaError('Error inesperado. Inténtalo de nuevo.')
    }
  }

  async function verificarMfaSetup() {
    setMfaError('')
    try {
      const { data: challengeData, error: challengeError } = await supabase.auth.mfa.challenge({ factorId: mfaFactorId })
      if (challengeError) { setMfaError('Error al verificar'); return }
      const { error: verifyError } = await supabase.auth.mfa.verify({
        factorId: mfaFactorId,
        challengeId: challengeData.id,
        code: mfaCodigo,
      })
      if (verifyError) { setMfaError('Código incorrecto. Inténtalo de nuevo.'); return }
      setMfaActivado(true)
      setMfaPaso('')
      setMfaCodigo('')
      setMensaje('Verificación en dos pasos activada.')
      setTimeout(() => setMensaje(''), 4000)
    } catch (err) {
      console.error("Error eliminar cuenta:", err)
      setMfaError('Error al verificar. Inténtalo de nuevo.')
    }
  }

  async function desactivarMfa() {
    const { error } = await supabase.auth.mfa.unenroll({ factorId: mfaFactorId })
    if (error) { setMfaError('Error al desactivar'); return }
    setMfaActivado(false)
    setMfaFactorId('')
    setMfaPaso('')
    setMensaje('Verificación en dos pasos desactivada.')
    setTimeout(() => setMensaje(''), 4000)
  }

  async function eliminarCuenta() {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user || emailConfirm !== user.email) {
      setError('El email no coincide con tu cuenta.')
      return
    }
    setEliminando(true)
    try {
      const uid = user.id
      await Promise.all([
        supabase.from('perfil').delete().eq('user_id', uid),
        supabase.from('ultimas_voluntades').delete().eq('user_id', uid),
        supabase.from('checklist_documentos').delete().eq('user_id', uid),
        supabase.from('messages').delete().eq('user_id', uid),
        supabase.from('heirs').delete().eq('user_id', uid),
        supabase.from('mascotas').delete().eq('user_id', uid),
      ])
      const { data: archivos } = await supabase.storage.from('mensajes-archivos').list(uid)
      if (archivos?.length > 0) {
        await supabase.storage.from('mensajes-archivos').remove(archivos.map(f => `${uid}/${f.name}`))
      }
      await fetch(`${API}/api/usuario/${uid}`, { method: 'DELETE' })
      await supabase.auth.signOut()
      window.location.href = '/'
    } catch (err) {
      console.error("Error eliminar cuenta:", err)
      setError('Error al eliminar la cuenta. Contacta con soporte en etern-me.com')
      setEliminando(false)
    }
  }

  return (
    <div style={estilos.pagina} className="pagina-contenido">
      <div style={estilos.contenido}>
        <div style={estilos.header}>
          <h2 style={estilos.titulo}>Privacidad y acceso</h2>
          <p style={estilos.subtitulo}>Gestiona el acceso y la privacidad de tu cuenta.</p>
        </div>
        {mensaje && <div style={estilos.mensajeExito}>{mensaje}</div>}
        {error && <div style={estilos.errorDiv}>{error}</div>}
        <div style={estilos.formulario}>

          <div style={estilos.seguridadBloque}>
            <h3 style={estilos.seguridadTitulo}>Cierre de sesión automático</h3>
            <p style={estilos.seguridadDesc}>Elige cuándo se cerrará tu sesión automáticamente al salir o minimizar la app. Recomendamos "Inmediato" para máxima seguridad.</p>
            <div style={estilos.timeoutOpciones}>
              {[
                { val: 'inmediato', label: 'Inmediato', desc: 'Máxima seguridad — se cierra al salir' },
                { val: '5min', label: '5 minutos', desc: 'Equilibrio entre seguridad y comodidad' },
                { val: '10min', label: '10 minutos', desc: 'Mayor comodidad' },
              ].map(op => (
                <button key={op.val} onClick={() => guardarTimeout(op.val)}
                  style={{ ...estilos.timeoutBtn, backgroundColor: timeoutSesion === op.val ? '#2C1810' : '#FAF8F5', color: timeoutSesion === op.val ? '#FAF8F5' : '#2C1810', border: timeoutSesion === op.val ? '2px solid #2C1810' : '1px solid #E8E0D5' }}>
                  <div style={estilos.timeoutLabel}>{op.label}</div>
                  <div style={{ ...estilos.timeoutDesc, color: timeoutSesion === op.val ? '#C4A882' : '#8B6F47' }}>{op.desc}</div>
                </button>
              ))}
            </div>
          </div>

          <div style={estilos.seguridadDivider} />

          <div style={estilos.seguridadBloque}>
            <h3 style={estilos.seguridadTitulo}>Verificación en dos pasos (2FA)</h3>
            <p style={estilos.seguridadDesc}>
              Añade una capa extra de seguridad. Al activarla, necesitarás un código
              de tu app de autenticación cada vez que inicies sesión.
            </p>
            {!mfaActivado && mfaPaso === "" && <button onClick={activarMfa} style={estilos.boton}>Activar verificación en dos pasos</button>}
            {mfaActivado && <button onClick={desactivarMfa} style={{ ...estilos.boton, backgroundColor: "#8B2E0F" }}>Desactivar 2FA</button>}
            {mfaPaso === "configurando" && (
              <div style={{ marginTop: "16px" }}>
                <p style={{ fontSize: "13px", color: "#5C4033", marginBottom: "12px" }}>Escanea este código QR con Google Authenticator o Authy:</p>
                <img src={mfaQR} alt="QR 2FA" style={{ width: "180px", height: "180px", display: "block", margin: "0 auto 16px" }} />
                <p style={{ fontSize: "12px", color: "#8B6F47", textAlign: "center", marginBottom: "16px" }}>Clave manual: {mfaSecret}</p>
                <input type="text" value={mfaCodigo} onChange={e => setMfaCodigo(e.target.value)} placeholder="Código de 6 dígitos" style={estilos.input} maxLength={6} />
                {mfaError && <p style={{ color: "#8B2E0F", fontSize: "13px", marginTop: "8px" }}>{mfaError}</p>}
                <button onClick={verificarMfaSetup} style={{ ...estilos.boton, marginTop: "12px" }}>Verificar y activar</button>
              </div>
            )}
          </div>

          <div style={estilos.seguridadDivider} />

          <div style={estilos.seguridadBloque}>
            <h3 style={{ ...estilos.seguridadTitulo, color: '#8B2E0F' }}>Eliminar cuenta</h3>
            <p style={estilos.seguridadDesc}>Esta acción eliminará permanentemente toda tu información. No se puede deshacer. Tus datos se borran en un máximo de 30 días conforme al RGPD.</p>
            {!confirmarEliminar ? (
              <button onClick={() => setConfirmarEliminar(true)} style={estilos.botonEliminarCuenta}>Eliminar mi cuenta</button>
            ) : (
              <div style={estilos.confirmarEliminar}>
                <p style={estilos.confirmarTexto}>Para confirmar, escribe tu email:</p>
                <input type="email" value={emailConfirm} onChange={e => setEmailConfirm(e.target.value)} style={estilos.input} placeholder="tu@email.com" />
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button onClick={() => { setConfirmarEliminar(false); setEmailConfirm('') }} style={estilos.botonCancelar}>Cancelar</button>
                  <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); eliminarCuenta() }} disabled={eliminando} style={{ ...estilos.botonEliminarCuenta, opacity: eliminando ? 0.7 : 1 }}>
                    {eliminando ? 'Eliminando...' : 'Confirmar eliminación'}
                  </button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: 'calc(100vh - 64px)', backgroundColor: '#FAF8F5', padding: '32px 16px', scrollMarginTop: '56px' },
  contenido: { maxWidth: '700px', margin: '0 auto' },
  header: { marginBottom: '24px' },
  titulo: { fontSize: '24px', fontWeight: '700', color: '#2C1810', marginBottom: '8px', letterSpacing: '-0.5px' },
  subtitulo: { fontSize: '14px', color: '#8B6F47', lineHeight: '1.7' },
  mensajeExito: { backgroundColor: '#F0F4E8', color: '#3D4D1F', padding: '12px 16px', borderRadius: '8px', fontSize: '14px', marginBottom: '16px', border: '1px solid #C8D5A0' },
  errorDiv: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', border: '1px solid #F5C9B8' },
  formulario: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '24px', border: '1px solid #E8E0D5' },
  input: { width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '14px', outline: 'none', backgroundColor: '#FAF8F5', color: '#2C1810', fontFamily: 'inherit' },
  boton: { width: '100%', padding: '13px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  seguridadBloque: { marginBottom: '8px' },
  seguridadTitulo: { fontSize: '16px', fontWeight: '600', color: '#2C1810', marginBottom: '8px' },
  seguridadDesc: { fontSize: '13px', color: '#8B6F47', lineHeight: '1.6', marginBottom: '16px' },
  seguridadDivider: { height: '1px', backgroundColor: '#E8E0D5', margin: '24px 0' },
  timeoutOpciones: { display: 'flex', flexDirection: 'column', gap: '10px' },
  timeoutBtn: { padding: '14px 16px', borderRadius: '10px', cursor: 'pointer', textAlign: 'left' },
  timeoutLabel: { fontSize: '15px', fontWeight: '600', marginBottom: '2px' },
  timeoutDesc: { fontSize: '12px' },
  botonEliminarCuenta: { width: '100%', padding: '13px', backgroundColor: '#8B2E0F', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  confirmarEliminar: { backgroundColor: '#FDF0EC', borderRadius: '10px', padding: '16px', border: '1px solid #F5C9B8', marginTop: '12px' },
  confirmarTexto: { fontSize: '14px', color: '#8B2E0F', marginBottom: '10px', fontWeight: '500' },
  botonCancelar: { flex: 1, padding: '11px', backgroundColor: 'transparent', color: '#2C1810', border: '1px solid #E8E0D5', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' },
}

export default Seguridad
